import React, { useState, useEffect } from "react";
import MainNavbar from "./MainNavbar";
import Hero from "./Hero";
import miniChiago from "../assets/images/mini-chicago.jpg";
import { SampleImages, Hotel, Tech, Politics, Retail, Sports, Cstores, Banking, Profit } from "./useCasesConstants";
import { Link } from "react-router-dom";
import { Footer } from "./Footer";
import AOS from "aos";
import "aos/dist/aos.css";


export const TestUseCases = () => {
    const [selectedCategory, setSelectedCategory] = useState("")
    const pillsArray = ["Sample", "Banking", "C-Stores", "Hotel and Gaming", "Mass Consumer", "Non Profits", "Politics", "Real Estate", "Retail", "Sports and entertainment", "Technology"]
    const [showCategories, setShowCategories] = useState([]);

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const handleSelected = (e) => {
        setSelectedCategory(e)
        switch (e) {
            case "Sample":
                setShowCategories(SampleImages);
                break;
            case "Banking":
                setShowCategories(Banking);
                break;
            case "C-Stores":
                setShowCategories(Cstores);
                break;
            case "Hotel and Gaming":
                setShowCategories(Hotel);
                break;
            case "Mass Consumer":
                setShowCategories(Retail);
                break;
            case "Non Profits":
                setShowCategories(Profit);
                break;
            case "Politics":
                setShowCategories(Politics);
                break;
            case "Sports and entertainment":
                setShowCategories(Sports);
                break;
            case "Technology":
                setShowCategories(Tech);
                break;
            default: setShowCategories(SampleImages)
        }
    }

    useEffect(() => {
        setShowCategories(SampleImages)
        setSelectedCategory("Sample")
    }, []);

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, [showCategories]);

    return (
        <>
            <MainNavbar />
            <Hero bgImage={miniChiago} imageText={{
                title: "Modern and Contemporary Use Cases",
                description: (
                    <>
                      <Link to="/">Home</Link> / Intellectual Property Use Cases
                    </>
                  )
            }} />
            <div className="bg-white relative flex flex-col min-h-screen w-full px-4 sm:px-8">
                <div className="bg-white shadow-lg rounded-lg w-full sm:w-10/12 md:w-8/12 lg:w-7/12 mx-auto p-4 border -mt-20">
                    <div className="flex flex-wrap justify-center items-center gap-2">
                        {pillsArray.map((item) => (
                            <span
                                key={item}
                                className={`px-3 py-1 sm:px-4 sm:py-2 border border-white rounded-md uppercase cursor-pointer text-sm sm:text-base
                        ${selectedCategory === item ? 'bg-[#F35F75] text-white' : 'bg-gray-200 text-black'}`}
                                onClick={() => handleSelected(item)}
                            >
                                {item}
                            </span>
                        ))}
                    </div>
                    <div
                        key={selectedCategory}
                        className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4 mt-4"
                        data-aos="fade-up"
                    >
                        {showCategories.map((item, index) => (
                            <div key={index} className="group overflow-hidden w-full">
                                <img
                                    src={item}
                                    className="w-full h-[200px] sm:h-[250px] object-cover transition-transform duration-500 ease-in-out group-hover:scale-150"
                                />
                            </div>
                        ))}
                    </div>
                    <p className="text-xs sm:text-sm mt-4 text-center">
                        * The following example Use Cases are for illustrative purposes and serve the purpose of showing how the Intellectual Property may be used in real-world scenarios. The actual extent of usage of the Intellectual Property and/or infringement, if any, are reserved.
                    </p>
                </div>
            </div>
                        <Footer />
        </>
    )
}